import AssessmentsAdapter from './base';

export default class Module extends AssessmentsAdapter {
  modelNamePlural = 'modules';
}
